import React from 'react';
import { ToggleButtonGroup } from 'react-bootstrap';
import ToggleButton from '../ToggleButton';

function SwitchToggle(props) {
  return <ToggleButtonGroup {...props} className="switch-toggle" />;
}

SwitchToggle.propTypes = {
  ...ToggleButtonGroup.propTypes,
};

SwitchToggle.defaultProps = {
  ...ToggleButtonGroup.defaultProps,
};

function SwitchToggleButton(props) {
  return <ToggleButton {...props} className="switch-toggle-button" variant="" />;
}

SwitchToggleButton.propTypes = {
  ...ToggleButton.propTypes,
};

SwitchToggleButton.defaultProps = {
  ...ToggleButton.defaultProps,
};

SwitchToggle.Button = SwitchToggleButton;
export default SwitchToggle;
